import React from 'react'
import { connect } from 'react-redux'
import injectSheet from 'react-jss'
import style from '../style'
import CameraList from '../CameraList'
import Switch from 'react-switch'
import { RECENT_DISPLAY_COUNT, COLORS } from 'helpers/globals'
import sortBy from 'ramda/src/sortBy'
import { recentModelsSelector, lensModelsSelector } from 'selectors/components'
import getCurrentCamera from 'helpers/cameras/getCurrentCamera'

const mapStateToProps = state => {
  const { cameraModels, favoriteModels = [], cameras } = state
  const currentCamera = getCurrentCamera(cameras)

  return {
    cameraModels: lensModelsSelector(state),
    favoriteModels,
    recentModels: recentModelsSelector(state),
    isFixedImager: currentCamera.isFixedImager
  }
}

class LensSelector extends React.Component {
  constructor(props) {
    super(props)
    const { cameraModels, favoriteModels, recentModels } = this.props

    this.state = {
      selectedCamera: null,
      cameras: sortBy(c => recentModels.indexOf(c.id) === -1 ? RECENT_DISPLAY_COUNT + 1 : recentModels.indexOf(c.id))(cameraModels),
      favoriteModels: favoriteModels || [],
      recentModels: recentModels,
      applySingle: false
    }
  }

  componentWillReceiveProps({ favoriteModels, recentModels }) {
    this.setState({
      favoriteModels,
      recentModels
    })
  }

  updateCameraList = selectedCamera =>
    this.setState({ selectedCamera })

  updateApply = checked =>
    this.setState({ applySingle: !checked })

  render() {
    const { updateCameraList, updateApply, state: { cameras, selectedCamera, favoriteModels, recentModels, applySingle }, props: { close, isFixedImager, classes } } = this

    return (
      <div className={classes.modelSelector}>
        <CameraList {...{ cameras, selectedCamera, initialCamera: null, initialAoV: null, updateCameraList, favoriteModels, recentModels, close, applySingle }} />
        { !isFixedImager &&
          <div className={classes.switchWrapper}>
            <label htmlFor="material-switch" className={classes.label}>
              <span>Apply To All Imagers</span>
              <Switch
                checked={!applySingle}
                onChange={updateApply}
                onColor="#5CA5E4"
                onHandleColor={COLORS.primary}
                handleDiameter={30}
                uncheckedIcon={false}
                checkedIcon={false}
                boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                height={20}
                width={48}
                className="react-switch"
                id="material-switch"
              />
            </label>
          </div>
        }
      </div>
    )
  }
}

export default connect(mapStateToProps)(injectSheet(style)(LensSelector))



// WEBPACK FOOTER //
// ./src/components/BottomBar/ModelSelector/LensSelector/index.js